import RequireAuth from "@/components/hoc/RequireAuth";
import RootLayout from "@/components/layout/RootLayout";
import useInjectSidebar from "@/hooks/useInjectSidebar";
import KpiInformation from "@/pages/kpi/_id/KpiInformation";
import KpiViewerLayout from "@/pages/kpi/_id/KpiViewerLayout";
import KpiDataLayout from "@/pages/kpi/_id/data/KpiDataLayout";
import KpiDataGoal from "@/pages/kpi/_id/data/goal/KpiDataGoal";
import KpiEditGoal from "@/pages/kpi/_id/data/goal/KpiEditGoal";
import KpiDataResult from "@/pages/kpi/_id/data/result/KpiDataResult";
import KpiEditResult from "@/pages/kpi/_id/data/result/KpiEditResult";
import KpiDataSummary from "@/pages/kpi/_id/data/summary/KpiDataSummary";
import KpiSettingLayout from "@/pages/kpi/_id/setting/KpiSettingLayout";
import KpiSettingAdvance from "@/pages/kpi/_id/setting/advance/KpiSettingAdvance";
import KpiSettingGeneral from "@/pages/kpi/_id/setting/general/KpiSettingGeneral";
import KpiSettingLink from "@/pages/kpi/_id/setting/link/Page";
import KpiSettingMember from "@/pages/kpi/_id/setting/members/KpiSettingMember";
import KpiSettingSegment from "@/pages/kpi/_id/setting/segment/KpiSettingSegment";
import KpiCreateNew from "@/pages/kpi/new/KpiCreateNew";
import KpiCreateNewLayout from "@/pages/kpi/new/KpiCreateNewLayout";
import { Navigate } from "react-router-dom";

const AppLayout = () => {
    const root = useInjectSidebar({ sidebarName: "workspace" })(RootLayout);

    return <RequireAuth>{root}</RequireAuth>;
};

export const kpiRoute = {
    path: "/kpis",
    element: <AppLayout />,
    children: [
        {
            path: ":kpiId",
            element: <KpiViewerLayout />,
            children: [
                {
                    index: true,
                    element: <Navigate to="./info" replace={true} />,
                },
                {
                    path: "info",
                    element: <KpiInformation />,
                },
                {
                    path: "data",
                    element: <KpiDataLayout />,
                    children: [
                        {
                            index: true,
                            element: <Navigate to="./summary" replace={true} />,
                        },
                        {
                            path: "summary",
                            element: <KpiDataSummary />,
                        },
                        {
                            path: "goal/edit",
                            element: <KpiEditGoal />,
                        },
                        {
                            path: "goal",
                            element: <KpiDataGoal />,
                        },
                        {
                            path: "result/edit",
                            element: <KpiEditResult />,
                        },
                        {
                            path: "result",
                            element: <KpiDataResult />,
                        },
                    ],
                },
                {
                    path: "settings",
                    element: <KpiSettingLayout />,
                    children: [
                        {
                            index: true,
                            element: <Navigate to="./general" repalce={true} />,
                        },
                        {
                            path: "general",
                            element: <KpiSettingGeneral />,
                        },
                        {
                            path: "segments",
                            element: <KpiSettingSegment />,
                        },
                        {
                            path: "link",
                            element: <KpiSettingLink />,
                        },
                        {
                            path: "members",
                            element: <KpiSettingMember />,
                        },
                        {
                            path: "advance",
                            element: <KpiSettingAdvance />,
                        },
                    ],
                },
            ],
        },
        {
            path: "new",
            element: <KpiCreateNewLayout />,
            children: [
                {
                    index: true,
                    element: <KpiCreateNew />,
                },
            ],
        },
        {
            path: "*",
            element: <div>KPI ID was not found.</div>,
        },
    ],
};
